import { m } from "motion/react";
import InkedText from "./inked-text";

export const reveal = {
	hidden: { opacity: 0, y: 32, filter: "blur(8px)" },
	visible: (i = 0) => ({
		opacity: 1,
		y: 0,
		filter: "blur(0px)",
		transition: { duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
	}),
};

const SectionHeading = ({ arabic, eyebrow, title, align = "center", inkDuration = 1.8 }) => {
	// arabic: the section's word in Arabic calligraphy (decorative, the title says it in English).
	const centered = align === "center";
	return (
		<div className={`mb-8 md:mb-20 ${centered ? "text-center" : "text-left"}`}>
			<div className="mb-1">
				<InkedText decorative duration={inkDuration} className={`text-[2.75rem] md:text-6xl ${centered ? "" : "-ml-2"}`}>
					{arabic}
				</InkedText>
			</div>
			<m.p
				className="eyebrow"
				variants={reveal}
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true }}
			>
				{eyebrow}
			</m.p>
			<m.h2
				className="mt-3 font-display text-4xl font-semibold tracking-tight text-parchment md:text-6xl"
				variants={reveal}
				custom={1}
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true }}
			>
				{title}
			</m.h2>
		</div>
	);
};

export default SectionHeading;
